export default [
    {
        path: '/design/static/seo-tool-seo-help',
        component: () => import('views/modules/cms/seo-tool/seo-help/index.vue'),
        meta: {
            title: 'SEO工具',
        },
    },
    {
        path: '/design/static/seo-tool-keywords-detail',
        component: () => import('views/modules/cms/seo-tool/seo-help/keywords-detail.vue'),
        meta: {
            title: '关键词详情',
        },
    },
    {
        path: '/design/static/helper',
        component: () => import('views/modules/cms/seo-tool/helper/index.vue'),
        meta: {
            title: 'SEO助手',
        },
    },
    {
        path: '/design/static/seo-tool-repetition-degree',
        component: () => import('views/modules/cms/seo-tool/repetition-degree/index.vue'),
        meta: {
            title: '重复度',
        },
    },
    {
        path: '/design/static/seo-tool-keyword-density',
        component: () => import('views/modules/cms/seo-tool/keyword-density/index.vue'),
        meta: {
            title: '关键词密度检测',
        },
    },
    {
        path: '/design/static/seo-tool-spider-log',
        component: () => import('views/modules/cms/seo-tool/spider-log/index.vue'),
        meta: {
            title: '蜘蛛抓取分析',
        },
    },
    {
        path: '/design/static/seo-tool-pagespider',
        component: () => import('views/modules/cms/seo-tool/pagespider/index.vue'),
        meta: {
            title: '页面抓取标记设置',
        },
    },
    {
        path: '/design/static/seo-tool-typical-page',
        component: () => import('views/modules/cms/seo-tool/typical-page/index.vue'),
        meta: {
            title: '典型页面设置',
        },
    },

    // 解决为设计器提供的交互页面，不应该带菜单啥的
    {
        path: '/design/form/app/detail/',
        name: 'form-detail',
        component: () => import('views/modules/np/form/app/detail'),
        meta: {
            // parent: '/nforaaCode3946id1126099852240760832',
            icon: 'el-icon-document',
            title: '表单详情',
            path: '',
            isApp: false,
            isIframe: false,
            isLink: false,
            isAffix: false,
            isHide: false,
            params: {},
        },
    },
    {
        path: '/design/segment-image',
        component: () => import('views/modules/cms/img-lib/lib/img-segment/index.vue'),
        meta: {
            title: '抠图工具',
        },
    },
];
